module.exports = __webpack_public_path__ + "static/media/TP_Icon_Annual.116929b0.png";